import { showNotification as showMantineNotification } from '@mantine/notifications';
import { Bug, Check } from 'tabler-icons-react';

export const showNotification = (message: string, options = {}) => {
  return showMantineNotification({
    autoClose: 3000,
    message,
    loading: false,
    ...options,
  });
};

export const showSuccessNotification = (message: string) => {
  return showNotification(message, {
    color: 'green',
    icon: <Check />,
  });
};

export const showErrorNotification = (error: string) => {
  return showNotification(error, {
    color: 'red',
    icon: <Bug />,
  });
};
